import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { environment } from 'src/environments/environment.dev-inte';
import { environment } from 'src/environments/environment';
import { RestRoutes } from '../_config/rest-routes.config';
import { DynamicForm } from '../_models/dynamic-form.model';

@Injectable({
  providedIn: 'root'
})
export class FileFormService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-Disposition': 'multipart/form-data'
      }
    )
  };

  constructor(private http: HttpClient) { }  

  postItem(formData: FormData): Observable<any>{
    let urlPostFileForm: string = ``;
    return this.http.post<any>(urlPostFileForm, formData, this.httpOptions)    
  }

  GetDynamicForm(dynamicFormId: any, claimId: any): Observable<{ dynamicForm: DynamicForm }> {
    const urlDynamicForm: string = `${environment.urlWS}${RestRoutes.DYNAMIC_FORM}/${dynamicFormId}/${claimId}`;
    return this.http.get<{ dynamicForm: DynamicForm }>(urlDynamicForm, this.httpOptions);
  }
}
